import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import VideoCard from "@/components/base/VideoCard";
import { getFeaturedVideos, getHotVideos, getLatestVideos } from "@/utils/videoUtils";

export default function Home() {
  const featured = getFeaturedVideos(4);
  const latest = getLatestVideos(8);
  const hot = getHotVideos(8);

  return (
    <div className="mx-auto w-full px-4 pb-16 pt-6 md:px-6 md:pt-8">
      <h1 className="sr-only">91抖音 - 精彩短视频分享平台</h1>

      <HeroCarousel videos={featured} />

      <section className="mt-12 md:mt-16">
        <div className="mb-5 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              视频分类
            </h2>
            <p className="mt-1.5 text-sm text-foreground-500">按兴趣挑选，快速找到你想看的内容</p>
          </div>
          <Link
            to="/category/entertainment"
            className="hidden whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700 sm:flex sm:items-center sm:gap-1"
          >
            全部分类
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <CategoryGrid />
      </section>

      <section className="mt-12 md:mt-16">
        <div className="mb-5 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              最新上传
            </h2>
            <p className="mt-1.5 text-sm text-foreground-500">刚刚发布的精彩短视频，第一时间刷到</p>
          </div>
          <Link
            to="/search"
            className="hidden whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700 sm:flex sm:items-center sm:gap-1"
          >
            更多视频
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 gap-x-4 gap-y-7 sm:grid-cols-2 lg:grid-cols-4">
          {latest.map((video) => (
            <VideoCard key={video.id} video={video} showCategory />
          ))}
        </div>
      </section>

      <section className="mt-12 md:mt-16">
        <div className="mb-5 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              <i className="ri-fire-fill mr-1.5 text-primary-500"></i>
              热门推荐
            </h2>
            <p className="mt-1.5 text-sm text-foreground-500">按播放量与点赞数实时排序</p>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-x-4 gap-y-7 sm:grid-cols-2 lg:grid-cols-4">
          {hot.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </section>

      <section className="mt-12 overflow-hidden rounded-lg bg-secondary-50 px-6 py-10 md:mt-16 md:px-12 md:py-14">
        <div className="flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-vidicon-line"></i>
              关于 91抖音
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              记录生活，分享此刻的精彩
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              91抖音汇聚娱乐、生活、音乐、美食、搞笑与游戏等多元内容，让每一次滑动都有惊喜。
              你可以收藏喜欢的视频、搜索感兴趣的话题，把快乐随时带在身边。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
            </Link>
            <Link
              to="/favorites"
              className="whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              查看我的收藏
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}